// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"Y3-z"};